import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileRole from './profile-role-model'
import {
  delete_profileRole,
  load_profileRoles,
  store_profileRole,
} from './profileRole-service'

export const LoadProfileRolesAsync = createAsyncThunk<any, any>(
  'composer/load/profileRole',
  async (params: { uid: string }) => {
    return await load_profileRoles(params)
  },
)

export const CreateProfileRoleAsync = createAsyncThunk<any, any>(
  'composer/create/profileRole',
  async (params: ProfileRole) => {
    return await store_profileRole(params)
  },
)

export const DeleteProfileRoleAsync = createAsyncThunk<any, any>(
  'composer/delete/profileRole',
  async (params) => {
    return await delete_profileRole(params)
  },
)
